module.exports = __webpack_public_path__ + "img/icon-search.612eb582.svg";